import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCwNfIsYU4-CfLJW02-mIov21SviHHZTjY",
  authDomain: "clone-8ad8e.firebaseapp.com",
  projectId: "clone-8ad8e",
  storageBucket: "clone-8ad8e.appspot.com",
  messagingSenderId: "702465049311",
  appId: "1:702465049311:web:3384117803a7a1a6811f6a",
  measurementId: "G-P2V3NE2SRV"
};

const firebaseApp=firebase.initializeApp(firebaseConfig);
const db=firebaseApp.firestore()
const auth=firebase.auth()

export {db,auth};